import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { DashboardLayout } from '@components/DashboardLayout.tsx';
import { PageIndices, TabIndices } from '../../common/i-doc/i-doc.registry.ts';
import { AdaptiveTabs } from '@components/common/AdaptiveTabs';
import { QuizBuilderListContent } from '../QuizBuilderPage';
import { QuestionnaireAnalyticsTab } from '../../components/admin/QuestionnaireAnalyticsTab';
import { adminQuestionnairesConstructionService } from '../../services/questionnaires-construction/questionnaires-construction.service';

/**
 * Адмінська версія `/quiz-builder` — повний доступ до абсолютно всіх шаблонів
 * (системних і будь-якого експерта), без перевірки власності. Той самий UI,
 * інший сервіс (`/admin/questionnaires-construction`) і шлях редагування.
 *
 * З 2026-06-23 — два таби: "Шаблони" (як і раніше) та "Аналітика" (загальносистемна
 * статистика відповідей по кожному шаблону, окремий ізольований модуль на бекенді).
 */
const AdminQuizBuilderPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') === 'analytics' ? 'analytics' : 'templates';

  return (
    <DashboardLayout>
      <Box data-i-doc={PageIndices.ADMIN_QUIZ_BUILDER}>
        <AdaptiveTabs
          tabs={[
            { value: 'templates', label: 'Шаблони', iDoc: TabIndices.ADMIN_QUIZ_BUILDER_TEMPLATES },
            { value: 'analytics', label: 'Аналітика', iDoc: TabIndices.ADMIN_QUIZ_BUILDER_ANALYTICS },
          ]}
          searchParamKey="tab"
          defaultValue="templates"
        />

        <Box sx={{ mt: 2 }} hidden={activeTab !== 'templates'}>
          <QuizBuilderListContent
            service={adminQuestionnairesConstructionService}
            editBasePath="/admin/quiz-builder"
            iDoc={PageIndices.ADMIN_QUIZ_BUILDER}
            isAdminMode
          />
        </Box>

        <Box sx={{ mt: 2 }} hidden={activeTab !== 'analytics'}>
          <QuestionnaireAnalyticsTab />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default AdminQuizBuilderPage;
